import type { ReactNode } from 'react';
import { View } from 'react-native';
import { ClubhouseWordmark } from './ui';
import { LegalFooter } from './legal';
import { styles } from '../theme';
import type { Screen, Translation } from '../types';

export function AuthChrome({
  t,
  setScreen,
  children,
}: {
  t: Translation;
  setScreen?: (screen: Screen) => void;
  children: ReactNode;
}) {
  return (
    <View>
      <View style={styles.screenTitleRow}>
        <ClubhouseWordmark />
      </View>
      {children}
      <LegalFooter
        t={t}
        onOpenDoc={
          setScreen
            ? key => {
                if (key === 'terms') setScreen('legalTerms');
                if (key === 'privacy') setScreen('legalPrivacy');
                if (key === 'cookies') setScreen('legalCookies');
              }
            : undefined
        }
      />
    </View>
  );
}
